import {returnToRow} from '@/utils/rowHighlight';

export default {
    created() { this._rowReturnVersion = 0; },
    beforeDestroy() { this.cancelPayrollRowReturn(); },
    watch: {
        periodMonth() { this.cancelPayrollRowReturn(); },
        activeTab() { this.cancelPayrollRowReturn(); },
        lineSortKey() { this.cancelPayrollRowReturn(); },
        lineSortDirection() { this.cancelPayrollRowReturn(); }
    },
    methods: {
        cancelPayrollRowReturn() {
            this._rowReturnVersion++;
            if (this._cancelRowReturn) this._cancelRowReturn();
            this._cancelRowReturn = null;
        },
        payrollReturnTarget() { return {key: this.editRowKey, month: this.periodMonth, version: this._rowReturnVersion}; },
        async returnToPayrollRow(target) {
            if (!target || !target.key) return;
            await this.$nextTick();
            // The summary watcher refreshes an open history asynchronously.
            if (this.employeeHistory && this._employeeHistoryRefresh) await this._employeeHistoryRefresh;
            await this.$nextTick();
            if (this._isDestroyed || target.month !== this.periodMonth || target.version !== this._rowReturnVersion) return;
            if (this._cancelRowReturn) this._cancelRowReturn();
            const resolve = () => this.$el.querySelectorAll && Array.from(this.$el.querySelectorAll('[data-payroll-line]'))
                .find(row => row.getAttribute('data-payroll-line') === target.key);
            this._cancelRowReturn = returnToRow(resolve, {
                container: row => {
                    for (let node = row.parentElement; node && node !== document.scrollingElement; node = node.parentElement) {
                        if (node.scrollHeight > node.clientHeight + 1 && /auto|scroll/.test(getComputedStyle(node).overflowY)) return node;
                    }
                    return document.scrollingElement;
                },
                bounds: (row, container) => this.payrollReturnBounds(row, container)
            });
        },
        payrollReturnBounds(row, container) {
            const viewport = document.documentElement.clientHeight;
            let top = container === document.scrollingElement ? 0 : Math.max(0, container.getBoundingClientRect().top);
            let bottom = container === document.scrollingElement ? viewport : Math.min(viewport, container.getBoundingClientRect().bottom);
            const period = this.$el.querySelector('.work-period-bar');
            if (period) top = Math.max(top, parseFloat(getComputedStyle(period).top) || 0);
            for (const selector of ['.work-period-bar', '.payroll-active-filters', '.payroll-scroll-header']) {
                const element = this.$el.querySelector(selector), rect = element && element.getBoundingClientRect();
                if (rect && rect.top <= top + 2 && rect.bottom > top) top = rect.bottom;
            }
            const panel = this.$el.querySelector('.payroll-line-editor.is-pinned');
            if (panel) {
                const rect = panel.getBoundingClientRect(), target = row.getBoundingClientRect();
                if (rect.right > target.left && rect.left < target.right && rect.top < bottom && rect.bottom > top) {
                    if (rect.top - top >= bottom - rect.bottom) bottom = Math.max(top, rect.top - 8);
                    else top = Math.min(bottom, rect.bottom + 8);
                }
            }
            return {top, bottom};
        }
    }
};
